import { isSourceConnected, isSourceConnectedIndividually, } from '#pplx/frontend/apps/ask/sources/hooks/sourceStatusPredicates.js';
export function sourcesToConnectors(sources, { aggregateFamilyStatus = true } = {}) {
    return sources.map((source) => {
        // Show the account flagged is_default (the one used for queries); fall back
        // to the first when none is flagged.
        const userConnection = ('user_connections' in source
            ? (source.user_connections?.find((connection) => connection.is_default) ??
                source.user_connections?.at(0))
            : null) ?? null;
        const connector = {
            ...source,
            name: source.id,
            connected: aggregateFamilyStatus
                ? isSourceConnected(source)
                : isSourceConnectedIndividually(source),
            picker_credentials: userConnection?.file_picker_credentials
                ? {
                    client_id: userConnection.file_picker_credentials.client_id ?? undefined,
                    api_key: userConnection.file_picker_credentials.api_key ?? undefined,
                    tenant_name: userConnection.file_picker_credentials.tenant_name,
                    expires_at: userConnection.file_picker_credentials.expires_at,
                    account_identifier: userConnection.file_picker_credentials.account_identifier ?? undefined,
                    scopes: userConnection.file_picker_credentials.scopes,
                }
                : null,
            connection_display_name: 'provider' in source && source.provider === 'merge'
                ? null
                : (userConnection?.connection_display_name ?? null),
            connection_uuid: userConnection?.connection_uuid ?? null,
            has_required_scopes: userConnection?.has_required_scopes ?? false,
            created_at: source.created_at ?? null,
            is_new: Boolean(source.is_new),
            auth_type: source.auth_type,
            capabilities: source.capabilities ?? {},
            // This field is defined as ConnectorError on the backend but it is always set to None in handle_get_connector_settings
            // keeping for now for backwards compatibility
            error: null,
            source,
        };
        return connector;
    });
}
//# sourceMappingURL=sourcesToConnectors.js.map